// extracted by mini-css-extract-plugin
module.exports = {"inviteContainer":"invite_inviteContainer__1LHOw","active":"invite_active__2YuRW"};